// use common.js, so we can consume the config modules in the build flow
module.exports = {

  __disabledAcFeatures: [
    'Common.Profiles',
    'Common.AgentGroups',
    'Common.Account_Info',
    'Analytics.LiveEngage_2_HotTopics',
    'Common.Multiple_Consumer_IDP',
    "Common.NLS_enabled",
    "Common.Legacy_Chat",
  ],
  __billingPageUrl: {
    GA: 'https://register.liveperson.com/user/login/myaccount',
    default: 'https://staging-register.liveperson.com/user/login/myaccount',
  },
  __isNewPlanApi: true,
  __showAccountInformation: true,
  __showAcFeatures: true,
  __showSiteSettings: true,
};
